import { useContext } from "react";
import AuthContext from "../contexts/authContext/AuthContext";

const useAuth = () => useContext(AuthContext);

export default useAuth;
